angular.module('Const').constant('Units', {
    weightUnit: [
        {
            value: 'grams',
            full: 'Grams',
            short: 'g'
        },
        {
            value: 'kilograms',
            full: 'Kilograms',
            short: 'kg'
        },
        {
            value: 'ounces',
            full: 'Ounces',
            short: 'oz'
        },
        {
            value: 'pounds',
            full: 'Pounds',
            short: 'lbs'
        }
    ],
    measureUnit: [
        {
            value: 'meters',
            full: 'Meters',
            short: 'm'
        },
        {
            value: 'centimeters',
            full: 'Centimeters',
            short: 'cm'
        },
        {
            value: 'inches',
            full: 'Inches',
            short: 'in'
        },
        {
            value: 'feet',
            full: 'Feet',
            short: 'ft'
        }
    ],
    getWeightUnit: function (weightUnit) {
        const unit = this.weightUnit.find((unit) => unit.value.toLowerCase() === weightUnit.toLowerCase());
        return unit ? unit.short.toUpperCase() : null;
    },
    getMeasureUnit: function (measureUnit) {
        const unit = this.measureUnit.find((unit) => unit.short.toLowerCase() === measureUnit.toLowerCase());
        return unit ? unit.short.toUpperCase() : null;
    }
});


// WEBPACK FOOTER //
// ./js/consts/units.js